import { useFilterStore } from "@faire/retailer-visitor-shared/components/Filters/useFilterStore";
import { SDUIOnViewActionsHandler } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/ActionHandler/SDUIOnViewActionHandler";
import { useConductorComponentDismissal } from "@faire/retailer-visitor-shared/features/Conductor/useConductorComponentDismissal";
import { useMaybeAssignCategoryTreeExperiment } from "@faire/retailer-visitor-shared/lib/useMaybeAssignCategoryTreeExperiment";
import { useRecordMilestoneByDay } from "@faire/retailer-visitor-shared/stores/domain/useMilestone";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";
export function useSDUIActionsHandler(actions, loggingData) {
    var history = useHistory();
    var recordMilestoneOnceByDay = useRecordMilestoneByDay();
    var clearAllFilters = useFilterStore([]).clearAllFilters;
    var maybeAssignCategoryTreeExperiment = useMaybeAssignCategoryTreeExperiment();
    var dismissSDUIConductorComponent = useConductorComponentDismissal().dismissSDUIConductorComponent;
    return useCallback(function() {
        SDUIOnViewActionsHandler(actions, loggingData, history, recordMilestoneOnceByDay, clearAllFilters, maybeAssignCategoryTreeExperiment, dismissSDUIConductorComponent);
    }, [
        actions,
        loggingData,
        history,
        recordMilestoneOnceByDay,
        clearAllFilters,
        maybeAssignCategoryTreeExperiment,
        dismissSDUIConductorComponent
    ]);
}
